import axios from 'axios';
import Vue from 'vue';
import store from '../store'
import router from '../router'

let axiosWrap = axios.create();
axiosWrap.defaults.timeout = 1000 * 60 * 8; // 超时响应
axiosWrap.defaults.withCredentials = true;
// POST application/x-www-form-urlencoded
axiosWrap.postByFormUrl = function (url, data, config) {
  return axiosWrap.post(url, data, {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    transformRequest: [function (data) {
      let ret = '';
      for (let item in data) {
        // 这些字段不需要提交
        if (item === 'creator' || item === 'created' || item === 'lastModifier' || item === 'lastModified') {
          continue;
        }
        if (data[item] === 0 || data[item] === '' || data[item] === false) {
          ret += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
        } else if (data[item]) {
          ret += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
        }
      }
      return ret.slice(0, ret.length - 1);
    }]
  })
};
// PUT application/x-www-form-urlencoded
axiosWrap.putByFormUrl = function (url, data, config) {
  return axiosWrap.put(url, data, {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    transformRequest: [function (data) {
      let ret = '';
      for (let item in data) {
        if (data[item] === 0 || data[item] === '' || data[item] === false) {
          ret += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
        } else if (data[item]) {
          ret += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
        }
      }
      return ret.slice(0, ret.length - 1);
    }]
  })
};
// PUT multipart/form-data
axiosWrap.putByFormData = function (url, data, config) {
  return axiosWrap.put(url, data, {
    ...config,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    transformRequest: [function (data) {
      let ret = new FormData();
      for (let item in data) {
        ret.append(item, data[item]);
      }
      return ret;
    }]
  })
};
// PUT multipart/form-data
axiosWrap.postByFormData = function (url, data, config) {
  return axiosWrap.post(url, data, {
    ...config,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    transformRequest: [function (data) {
      let ret = new FormData();
      for (let item in data) {
        ret.append(item, data[item]);
      }
      return ret;
    }]
  })
};
// POST application/json
axiosWrap.postByJson = function (url, data) {
  return axiosWrap.post(url, data, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    transformRequest: [function (data) {
      // debugger
      // let ret = ''
      // for (let item in data) {
      //   // 这些字段不需要提交
      //   if (item === 'creator' || item === 'created' || item === 'lastModifier' || item === 'lastModified') {
      //     continue
      //   }
      //   if (data[item] === 0 || data[item] === '' || data[item] === false) {
      //     ret += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
      //   } else if (data[item]) {
      //     ret += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
      //   }
      // }
      // return ret.slice(0, ret.length - 1)
      return JSON.stringify(data)
    }]
  })
};
// 请求拦截器
axiosWrap.interceptors.request.use(request => {
  if (!request.anon && !store.state.token) {
    return Promise.reject(new Error('未登录'))
  } else {
    request.headers.common['X-Auth-Token'] = store.state.token;
    request.headers.common['Accept-Language'] = store.state.language === 'chinese' ? 'cn_ZH' : 'en_US';
  }
  let resource = request.resource;
  if (resource && !Vue.prototype.$auth(resource)) {
    return Promise.reject(new Error('No Access'))
  }
  return request;
}, error => {
  return Promise.reject(error);
});
// 响应拦截器 响应码处理
axiosWrap.interceptors.response.use(res => {
  if (res.data) {
    if (res.data.code === 401) {
      router.replace('/login');
      if (store.state.token) {
        store.commit('token', null);
        localStorage.removeItem("access_token");
        Vue.prototype.$message.error('登录状态已失效,请重新登录');
      }
      return Promise.reject(res.data);
    } else if (res.data.code <= 0 || res.data.code > 1) {
      let message = res.data.message ? res.data.message : '操作失败';
      Vue.prototype.$message.error(message);
      console.error(res);
      return Promise.reject(res.data);
    }
  }
  return res.data
}, error => {
  if (error.response && error.response.data) {
    // 请求已发出，但服务器响应的状态码不在 2xx 范围内
    Vue.prototype.$loading({
      base_showLoading:true,
      base_status:"failed",
      base_failedTxt:error.response.data.message || error.response.data,
      base_duration: 3000
    });
    // Vue.prototype.$message.error(error.response.data.message || error.response.data);
    return Promise.reject(error)
  } else {
    if (error.message === '未登录') {
      router.replace('/login');
    }
    return Promise.reject(error)
  }
});
export default axiosWrap;
